(() => {
  'use strict';
  const dialog = document.getElementById('pl-swiss-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'pl-swiss-popup-v1';
  const preview = window.Shopify?.theme?.role !== 'main' && new URLSearchParams(location.search).get('pl_swiss_preview') === '1';
  let previousFocus, previousOverflow, shown = false;
  const remember = () => { if (!preview) { try { localStorage.setItem(key,String(Date.now())); } catch (_) {} } };
  const dismiss = () => { remember(); dialog.close(); };
  dialog.addEventListener('cancel', remember);
  dialog.querySelectorAll('[data-pl-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    remember();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss();
  });
  function openWhenFree(deadline) {
    if (shown || document.visibilityState === 'hidden') return;
    const otherModal = [...document.querySelectorAll('dialog[open],.modal--is-active,.drawer--is-open,[aria-modal="true"]:not(#pl-swiss-popup),#shopify-pc__banner')].some(el => el.getClientRects().length > 0);
    if (otherModal) {
      if (Date.now() < deadline) setTimeout(() => openWhenFree(deadline), 2000);
      return;
    }
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    shown = true;
  }
  async function start() {
    if (preview) { openWhenFree(Date.now()+60000); return; }
    if (dialog.dataset.editor === 'true' || /\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname)) return;
    if (document.querySelector('[data-pl-relay-page]')) return;
    try { if (Date.now()-Number(localStorage.getItem(key)) < 7*86400000) return; } catch (_) {}
    try {
      const response = await fetch(dialog.dataset.geo,{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(4000)});
      if (!response.ok) return;
      const result = await response.json();
      if (result.switzerland === true) setTimeout(() => openWhenFree(Date.now()+60000),1200);
    } catch (_) { /* The storefront stays usable if detection is unavailable. */ }
  }
  start();
})();
